import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { PERMISSION_ADMINMESSAGES_WRITE } from "../../../../../constants";
import ProtectedElement from "../../../../common/helpers/ProtectedElement";

const NewAdminMessageButton = ({ className, skillVendorIds, vacancyId, recipients, vacancyCandidateStatus, history }) => {
  const [urlSearchParams, setUrlSearchParams] = useState(new URLSearchParams());

  useEffect(
    () => {
      let params = new URLSearchParams({ skillVendorIds: skillVendorIds, vacancyId: vacancyId, recipients: recipients, vacancyCandidateStatus: vacancyCandidateStatus });
      params.forEach((value, key) => {
        if (value === "undefined" || value === "" || value === undefined) {
          params.delete(key);
        }
      });

      setUrlSearchParams(params);
    },
    [skillVendorIds, vacancyId, recipients, vacancyCandidateStatus]
  );

  return (
    <ProtectedElement permission={PERMISSION_ADMINMESSAGES_WRITE}>
      <button
        className={`btn btn-rounded btn-primary ${className}`}
        onClick={() =>
          history.push({
            pathname: "/adminMessages/create",
            search: "?" + urlSearchParams.toString(),
          })
        }
      >
        New message
      </button>
    </ProtectedElement>
  );
};

export default withRouter(NewAdminMessageButton);
